import { Component, Vue } from 'vue-property-decorator'
import { PHONE_WIDTH, TABLET_PORTRAIT_WIDTH } from './constants'

@Component
export default class Mixin extends Vue {
  isPhone: boolean = window.outerWidth <= PHONE_WIDTH

  isTabletP: boolean = window.outerWidth > PHONE_WIDTH && window.outerWidth <= TABLET_PORTRAIT_WIDTH

  isPhoneAndTablet: boolean = window.outerWidth <= TABLET_PORTRAIT_WIDTH

  updateDeviceType(): void {
    this.isPhone = window.outerWidth <= PHONE_WIDTH
    this.isTabletP = window.outerWidth > PHONE_WIDTH && window.outerWidth <= TABLET_PORTRAIT_WIDTH
    this.isPhoneAndTablet = window.outerWidth <= TABLET_PORTRAIT_WIDTH
  }

  mounted(): void {
    window.addEventListener('resize', this.updateDeviceType)
  }
}
